import { mapState } from 'vuex';

import Calendar from '@/components/Calendar';
import { EventFeeFunctions } from '@/enums/eventFeeFunctions.enum';
import { EventFunctions } from '@/enums/eventFunctions.enum';
import { TableName } from '@/enums/tableName.enum';
import { modalMixin } from '@/mixins/modal';
import { eventsTranslate } from '@/utils/calendar';
import { EVENT_FEE_COLOR } from '@/utils/constants';
import { tryParseInt } from '@/utils/number';
import { getTimePeriod } from '@/utils/time';

export const calendarMixin = {
  components: { Calendar },
  mixins: [
    modalMixin('schedule', {
      added: 'messages.schedule.added',
      addError: 'messages.schedule.addError',
      updated: 'messages.schedule.updated',
      updateError: 'messages.schedule.updateError'
    })
  ],
  data() {
    return {
      selectedEvent: {}
    };
  },
  computed: {
    ...mapState({
      events: state => [
        ...eventsTranslate([...state.events.list]),
        ...eventsTranslate([...state.fee.events.list], EVENT_FEE_COLOR)
      ]
    })
  },
  methods: {
    // @vuese
    // Otwiera modal wydarzenia
    showEventModal(event) {
      this.selectedEvent = event;

      this.showEditModal(event.eventContainerId);
    },

    // @vuese
    // Ukrywa modal wydarzenia
    hideModal() {
      this.selectedEvent = {};
      this.$set(this, 'showModal', false);
      this.$set(this, 'idToEdit', undefined);
    },

    // @vuese
    // Odświeża listę wydarzeń
    refreshEvents() {
      const timePeriod = getTimePeriod(
        this.$route.params.view,
        this.$route.query.year,
        this.$route.query.month,
        this.$route.query.day
      );

      Promise.all([
        this.$store.dispatch('events/list', {
          id: tryParseInt(this.$route.params.clubId),
          eventType: EventFunctions[TableName.Club],
          start: timePeriod.start,
          end: timePeriod.end
        }),
        this.$store.dispatch('fee/events/list', {
          id: tryParseInt(this.$route.params.clubId),
          eventType: EventFeeFunctions[TableName.Club],
          start: timePeriod.start,
          end: timePeriod.end
        })
      ]).catch(() => this.$store.dispatch('notifyError', { title: 'messages.errorShort' }));
    }
  }
};
